import Swal from 'sweetalert2';

export const useSwalNotification = () => {
  const showSwalNotification = ({
    title,
    text,
    icon,
    showConfirmButton = true,
    confirmButtonText = 'OK',
    confirmCallback,
    declineCallback,
  }: {
    title: string;
    text: string;
    icon: 'success' | 'error' | 'warning' | 'info' | 'question';
    showConfirmButton?: boolean;
    confirmButtonText?: string;
    confirmCallback?: () => void;
    declineCallback?: () => void;
  }) => {
    Swal.fire({
      title,
      text,
      icon,
      showConfirmButton,
      confirmButtonText,
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback && confirmCallback();
      } else {
        declineCallback && declineCallback();
      }
    });
  };

  const showErrorNotification = ({
    title,
    text,
    showConfirmButton = true,
    confirmButtonText = 'OK',
    confirmCallback,
    declineCallback,
  }: {
    title: string;
    text: string;
    showConfirmButton?: boolean;
    confirmButtonText?: string;
    confirmCallback?: () => void;
    declineCallback?: () => void;
  }) => {
    Swal.fire({
      title,
      text,
      icon: 'error',
      showConfirmButton,
      confirmButtonText,
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback && confirmCallback();
      } else {
        declineCallback && declineCallback();
      }
    });
  };

  return { showSwalNotification, showErrorNotification };
};
